import { Suspense } from 'react';

import type { NavigationScreenTranslationState } from '@gitbook/app-navigation';
import { LoadingPanel } from '@gitbook/spine-react';
import { HeadTitle } from '@gitbook/util-react-head';

import { APIErrorBoundary, OrganizationMissingPermRedirect } from '../../Components';
import { NavigationScreenWithOrganization } from '../../navigation';
import { GlossaryView } from './GlossaryView';
import { TranslationsOverview } from './Overview';
import { TranslationsScreenLayout } from './TranslationsScreenLayout';

/**
 * Home screen for translations.
 */
export function TranslationsScreen(props: { screen: NavigationScreenTranslationState }) {
    return (
        <NavigationScreenWithOrganization screen={props.screen}>
            {({ screen }) => (
                <APIErrorBoundary
                    fallback={{
                        403: (
                            <OrganizationMissingPermRedirect
                                title="Error while accessing translations"
                                organizationId={screen.organization}
                            />
                        ),
                    }}
                >
                    <HeadTitle title="Translations" />
                    <TranslationsScreenWithOrganization screen={screen} />
                </APIErrorBoundary>
            )}
        </NavigationScreenWithOrganization>
    );
}

function TranslationsScreenWithOrganization(props: {
    screen: NavigationScreenTranslationState & { organization: string };
}) {
    const { screen } = props;

    return (
        <Suspense
            fallback={
                <TranslationsScreenLayout screen={screen}>
                    <LoadingPanel size="large" />
                </TranslationsScreenLayout>
            }
        >
            <TranslationsHome screen={screen} />
        </Suspense>
    );
}

function TranslationsHome(props: {
    screen: NavigationScreenTranslationState & { organization: string };
}) {
    const { screen } = props;

    if (screen.view === 'overview') {
        return <TranslationsOverview screen={screen} />;
    }

    return <GlossaryView screen={screen} />;
}
